<template>
<v-container>
  <div style="display: none">
    <EditDialog
      v-bind:model="editCategory"
      v-bind:moduleName="'stock_parts'"
      v-bind:btnName="''"
      v-bind:formTitle="$t('actions.choose_category')"
      @save="saveCategoryEvent"
      @close="cleanupCategoryDialog"
      ref="editDialogCategory"
    >
      <template v-slot:edit_content>
        <CategoryForm></CategoryForm>
      </template>
    </EditDialog>
  </div>
  <v-dialog
    v-model="imageInLarge"
    max-width="90vw"
    transition="scale-transition"
    content-class="imageInLargeDialog"
    @click:outside="imageInLarge = false"
  >
    <!-- Any click that is not on the picture itself closes the zoom -->
    <div class="image-in-large" @click="imageInLarge = false">
      <v-btn
        class="mx-auto"
        icon="true"
        color="secondary"
        @click.stop="imageInLarge = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <img :src="imageInLargeSrc" alt="" @click.stop />
    </div>
  </v-dialog>

  <v-dialog
    v-model="showImportPart"
    max-width="75%"
    @click:outside="showImportPart = false"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{
            $filters.capitalize($t("parts.form_title_import"))
          }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <PartForm
            v-bind:askStockPart="true"
            v-bind:askStockage="false"
            v-bind:stockageId="stockage_id"
            v-bind:producerTypeId="producer_type_id"
          ></PartForm>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary lighten-2"
          variant="text"
          @click="showImportPart = false"
        >{{ $filters.capitalize($t("cancel")) }}
        </v-btn
        >
        <v-btn color="success" @click="saveImportStockPart()">{{
            $filters.capitalize($t("add"))
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="showSerialsModal"
    max-width="52em"
    scrollable
    @click:outside="showSerialsModal = false"
  >
    <v-card>
      <v-toolbar flat color="white">
        <v-icon class="ml-4 mr-2">mdi-barcode</v-icon>
        <v-toolbar-title class="text-capitalize">
          {{ editedLine ? editedLine.name : "" }}
          <v-chip size="small" label class="ml-2">
            {{ serialRows.length }} {{ $t("units.label", serialRows.length) }}
          </v-chip>
        </v-toolbar-title>
        <v-tooltip location="top" :text="$filters.capitalize($t('actions.edit'))">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              icon="mdi-pencil"
              size="small"
              variant="text"
              @click="createFullPart(editedLine)"
              @click.right="createFullPart_newTab(editedLine)"
            ></v-btn>
          </template>
        </v-tooltip>
        <v-btn
          icon="mdi-close"
          size="small"
          variant="text"
          @click="showSerialsModal = false"
        ></v-btn>
      </v-toolbar>

      <v-card-text class="pt-2">
        <v-text-field
          v-if="serialRows.length > 5"
          v-model="serialsFilter"
          prepend-inner-icon="mdi-magnify"
          :label="$filters.capitalize($t('search'))"
          density="compact"
          variant="outlined"
          hide-details
          clearable
          class="mb-2"
        ></v-text-field>

        <v-data-table
          :headers="serialHeaders"
          :items="serialRows"
          :search="serialsFilter"
          :items-per-page="-1"
          density="compact"
          hide-default-footer
          hover
        >
          <template v-slot:item.serial="{ item }">
            <span class="font-weight-medium">{{ item.serial || "-" }}</span>
          </template>
          <template v-slot:item.qr_code="{ item }">
            <v-chip
              v-if="item.qr_code"
              size="small"
              label
              prepend-icon="mdi-qrcode"
            >{{ item.qr_code }}</v-chip>
            <span v-else class="text-disabled">
              {{ $t("part_view.no_qr_code") }}
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              v-if="item.id || item.qr_code"
              location="top"
              :text="$filters.capitalize($t('units.actions.view_item'))"
            >
              <template v-slot:activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="1em"
                  @click="viewUnit(item)"
                >mdi-open-in-new</v-icon>
              </template>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="showAddConsumable"
    max-width="75%"
    @click:outside="showAddConsumable = false"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{
            $filters.capitalize($t("consumables.form_title"))
          }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <ConsumableForm
            v-bind:askStockPart="false"
            v-bind:askStockage="false"
            v-bind:stockageId="stockage_id"
            v-bind:placeId="place_id"
          ></ConsumableForm>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary lighten-2"
          variant="text"
          @click="showAddConsumable = false"
        >{{ $filters.capitalize($t("cancel")) }}
        </v-btn>
        <v-btn color="success" @click="saveAddConsumableItem()">{{
            $filters.capitalize($t("save"))
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="showAddPart"
    max-width="75%"
    @click:outside="showAddPart = false"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{
            $filters.capitalize($t("units.form_title"))
          }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <UnitForm
            :key="stock_part_id"
            v-bind:askStockPart="false"
            v-bind:askStockage="false"
            v-bind:stockageId="stockage_id"
            v-bind:placeId="place_id"
            v-bind:stockPartId="stock_part_id"
          ></UnitForm>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary lighten-2"
          variant="text"
          @click="showAddPart = false"
        >{{ $filters.capitalize($t("cancel")) }}
        </v-btn
        >
        <v-btn color="success" @click="saveAddPartItem()">{{
            $filters.capitalize($t("save"))
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="showDateSelection"
    max-width="480"
    :fullscreen="isMobile"
    @click:outside="closeDateSelection"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-download</v-icon>
        {{ $filters.capitalize($t("part_view.export.title")) }}
        <v-spacer></v-spacer>
        <v-btn icon="mdi-close" variant="text" size="small" @click="closeDateSelection"></v-btn>
      </v-card-title>

      <v-card-text>
        <!-- stock state: now or at a past date -->
        <div class="text-caption text-medium-emphasis mb-1">
          {{ $filters.capitalize($t("part_view.export.state")) }}
        </div>
        <v-btn-toggle
          v-model="exportMode"
          color="primary"
          variant="outlined"
          divided
          mandatory
          class="mb-4 w-100"
        >
          <v-btn value="current" class="flex-grow-1" prepend-icon="mdi-clock-outline">
            {{ $filters.capitalize($t("part_view.export.current")) }}
          </v-btn>
          <v-btn value="at_date" class="flex-grow-1" prepend-icon="mdi-calendar-clock">
            {{ $filters.capitalize($t("part_view.export.at_date")) }}
          </v-btn>
        </v-btn-toggle>

        <v-expand-transition>
          <div v-if="exportMode === 'at_date'" class="mb-2">
            <v-menu
              v-model="exportDateMenu"
              :close-on-content-click="false"
              location="bottom"
            >
              <template v-slot:activator="{ props }">
                <v-text-field
                  v-bind="props"
                  :model-value="exportDateLabel"
                  :label="$filters.capitalize($t('part_view.export.date'))"
                  :placeholder="$t('part_view.export.pick_date')"
                  prepend-inner-icon="mdi-calendar"
                  variant="outlined"
                  density="comfortable"
                  readonly
                  clearable
                  @click:clear="exportDate = undefined"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="exportDate"
                :max="new Date()"
                show-adjacent-months
                @update:modelValue="exportDateMenu = false"
              ></v-date-picker>
            </v-menu>
            <div class="text-caption text-medium-emphasis">
              {{ $t("part_view.export.at_date_hint") }}
            </div>
            <v-checkbox
              v-model="exportDetails"
              :label="$t('part_view.export.details')"
              :hint="$t('part_view.export.details_hint')"
              persistent-hint
              density="compact"
              class="mt-2"
            ></v-checkbox>
          </div>
        </v-expand-transition>

        <!-- file format -->
        <div class="text-caption text-medium-emphasis mb-1 mt-2">
          {{ $filters.capitalize($t("part_view.export.format")) }}
        </div>
        <v-btn-toggle
          v-model="exportFormat"
          color="primary"
          variant="outlined"
          divided
          mandatory
          class="mb-2 w-100"
        >
          <v-btn value="CSV" class="flex-grow-1" prepend-icon="mdi-file-delimited-outline">CSV</v-btn>
          <v-btn value="PDF" class="flex-grow-1" prepend-icon="mdi-file-pdf-box">PDF</v-btn>
        </v-btn-toggle>

        <v-checkbox
          v-model="expandTrackedPart"
          :label="$t('part_view.export.expand_tracked_parts')"
          density="compact"
          hide-details
        ></v-checkbox>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="closeDateSelection">
          {{ $filters.capitalize($t("cancel")) }}
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          prepend-icon="mdi-download"
          :loading="loadingExport"
          :disabled="!canExport"
          @click="exportList()"
        >
          {{ $filters.capitalize($t("part_view.export.label")) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- ========================== End dialogs ======================== -->
  <v-toolbar elevation="1" color="white" class="px-2">
    <v-btn
      id="menu-activator"
      class="hidden-md-and-up"
      icon="mdi-menu"
      variant="text"
      :disabled="disableControls"
    ></v-btn>

    <v-menu activator="#menu-activator">
      <v-list class="d-flex flex-column">
        <v-btn
          color="primary"
          class="mb-2 mx-2"
          :disabled="disableControls"
          @click.prevent="showDateSelection=true"
          >{{  $filters.capitalize($t(`part_view.export.label`))}} 
          <v-progress-circular
            class="ml-3"
            v-show="loadingExport"
            :indeterminate="true"
          ></v-progress-circular>
        </v-btn>
<v-btn
          color="primary"
          class="mb-2 mx-2"
          :disabled="disableControls"
          @click.prevent="showImportPartEvent()"
        >{{ $filters.capitalize($t(`part_view.import_sp`)) }}
        </v-btn>
        <v-btn
          color="primary"
          class="mx-2"
          :disabled="disableControls"
          @click.prevent="createFullPart(undefined)"
        >{{ $filters.capitalize($t(`part_view.create_full`)) }}
        </v-btn>
      </v-list>
    </v-menu>

    <v-toolbar-items>
      <MenuStock
        v-bind:stockage_id="stockage_id"
        v-bind:loading="loadingStock"
        @chooseStock="menuChoose"
        @producerTypes="setProducerTypes"
      ></MenuStock>
    </v-toolbar-items>
    <v-spacer></v-spacer>

    <v-toolbar-title class="text-center text-h6 font-weight-bold">
      <v-icon size="small" class="mr-2" color="primary">mdi-package-variant</v-icon>
      {{ $filters.capitalize($t(pageTitle, 10)) }}
    </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-toolbar-items class="hidden-sm-and-down align-center">
      <v-btn
        class="mr-2"
        color="primary"
        variant="tonal"
        prepend-icon="mdi-download"
        :loading="loadingExport"
        :disabled="disableControls"
        @click.prevent="showDateSelection = true"
      >{{ $filters.capitalize($t(`part_view.export.label`)) }}
      </v-btn>

      <v-btn
        class="mr-2"
        color="primary"
        variant="tonal"
        prepend-icon="mdi-file-import"
        :disabled="disableControls"
        @click.prevent="showImportPartEvent()"
      >{{ $filters.capitalize($t(`part_view.import_sp`)) }}
      </v-btn>

      <v-btn
        color="primary"
        variant="flat"
        prepend-icon="mdi-plus"
        :disabled="disableControls"
        @click.prevent="createFullPart(undefined)"
      >{{ $filters.capitalize($t(`part_view.create_full`)) }}
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>

  <!-- ================= phone layout (sm and down) ================= -->
  <div v-if="isMobile" class="part-mobile">
    <!-- filters: stay at the top while the list scrolls -->
    <v-sheet class="pa-2 part-mobile__filters" elevation="1">
      <v-text-field
        v-model="searchText"
        :label="$filters.capitalize($t('search'))"
        prepend-inner-icon="mdi-magnify"
        single-line
        variant="outlined"
        density="compact"
        hide-details
        clearable
      ></v-text-field>
      <div class="d-flex mt-2" style="gap: 8px">
        <v-btn
          id="p_type_activator_mobile"
          class="flex-grow-1"
          color="primary"
          variant="tonal"
          size="small"
          :disabled="producer_types.length <= 1"
          prepend-icon="mdi-wind-turbine"
          append-icon="mdi-menu-down"
        >
          {{ producer_type_name }}
        </v-btn>
        <v-menu activator="#p_type_activator_mobile">
          <v-list density="compact">
            <v-list-item
              v-show="producer_type_id != undefined"
              @click="clearProducerType()"
              :title="$filters.capitalize($t('producer_types.all'))"
            ></v-list-item>
            <v-list-item
              v-for="p_type in producer_types"
              :key="p_type.full_name"
              :active="p_type.producer_type_id === producer_type_id"
              @click="selectProducerType(p_type)"
            >
              <v-list-item-title>{{ p_type.producer_type_name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-select
          class="flex-grow-1"
          v-model="unityFilterValues"
          :items="unityOptions"
          :label="$filters.capitalize($t('unity.label', 1))"
          multiple
          chips
          closable-chips
          clearable
          variant="outlined"
          density="compact"
          hide-details
        ></v-select>
      </div>
      <div class="d-flex align-center justify-space-between mt-1 text-caption text-medium-emphasis">
        <span>{{ mobileItems.length }} {{ $t("part_view.label", mobileItems.length) }}</span>
        <span>
          <v-btn
            v-show="hasActiveFilters"
            icon="mdi-filter-remove-outline"
            variant="text"
            size="x-small"
            @click="clearFilters()"
          ></v-btn>
          <v-btn
            :icon="grouped ? 'mdi-format-list-group' : 'mdi-format-list-bulleted'"
            :color="grouped ? 'primary' : undefined"
            variant="text"
            size="x-small"
            :title="$filters.capitalize($t('part_view.group_by_category'))"
            @click="toggleGrouped()"
          ></v-btn>
        </span>
      </div>
    </v-sheet>

    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>

    <!-- grouped by category -->
    <v-expansion-panels v-if="grouped" v-model="mobileOpenGroups" multiple variant="accordion" class="mt-2">
      <v-expansion-panel
        v-for="group in mobileGroups"
        :key="group.name"
        :value="group.name"
      >
        <v-expansion-panel-title class="py-2">
          <span class="font-weight-bold text-uppercase">{{ group.name || $t("part_view.no_category") }}</span>
          <v-chip size="x-small" label class="ml-2">{{ group.items.length }}</v-chip>
          <v-chip v-if="group.low > 0" size="x-small" label color="error" class="ml-1">
            {{ group.low }} {{ $t("part_view.low_stock") }}
          </v-chip>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <PartMobileCard
            v-for="item in group.items"
            :key="item.stockpartlimit_id"
            :item="item"
            :staff="isFromStaff"
            :low="isLowStock(item)"
            :show-category="false"
            class="mb-2"
            @zoom="zoom(item.image_url)"
            @add="addItemBtn"
            @remove="removeItem"
            @serials="showSerials"
            @edit="createFullPart"
            @delete="disableLine"
          ></PartMobileCard>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- flat list -->
    <div v-else class="pa-2">
      <PartMobileCard
        v-for="item in mobileItems.slice(0, mobileLimit)"
        :key="item.stockpartlimit_id"
        :item="item"
        :staff="isFromStaff"
        :low="isLowStock(item)"
        class="mb-2"
        @zoom="zoom(item.image_url)"
        @add="addItemBtn"
        @remove="removeItem"
        @serials="showSerials"
        @edit="createFullPart"
        @delete="disableLine"
      ></PartMobileCard>
    </div>

    <!-- new part -->
    <v-btn
      icon="mdi-plus"
      color="primary"
      size="large"
      elevation="4"
      class="part-mobile__fab"
      :disabled="disableControls"
      :title="$filters.capitalize($t('part_view.create_full'))"
      @click="createFullPart(undefined)"
    ></v-btn>

    <div v-if="mobileItems.length > mobileLimit" class="text-center my-3">
      <v-btn variant="tonal" color="primary" @click="mobileLimit += mobileStep">
        {{ $filters.capitalize($t("part_view.show_more")) }}
        ({{ mobileItems.length - mobileLimit }})
      </v-btn>
    </div>
  </div>

  <v-data-table
    v-else
    v-model="selected"
    :headers="headers"
    :items="items"
    :items-per-page="itemsPerPage"
    :items-per-page-text='$t("rows_per_page")'
    :items-per-page-options='itemsPerPageOptions'
    :row-props="bgClass"
    :group-by="groupBy"
    :filter-keys="['category_name','name','name_en','ref','serials','qr_codes']"
    :custom-filter='customFilter'
    :loading="loading"
    item-value="stock_part_id"
    fixed-header
    show-select
    :search="searchQuery"
  >
    <!--      no footer :: pagination info-->
    <template #top>
      <v-row align="center" class="px-2 py-1 ma-0" dense>
        <!-- ================= filters (left) ================= -->
        <v-col cols="12" sm="6" md="4" lg="3">
          <v-text-field
            v-model="searchText"
            :label="$filters.capitalize($t('search'))"
            prepend-inner-icon="mdi-magnify"
            single-line
            variant="outlined"
            density="comfortable"
            hide-details
            clearable
          ></v-text-field>
        </v-col>

        <v-col cols="6" sm="3" md="auto">
          <v-btn
            id="p_type_activator"
            color="primary"
            variant="tonal"
            block
            :disabled="producer_types.length <= 1"
            prepend-icon="mdi-wind-turbine"
            append-icon="mdi-menu-down"
          >
            {{ producer_type_name }}
          </v-btn>
          <v-menu activator="#p_type_activator">
            <v-list density="compact">
              <v-list-item
                v-show="producer_type_id != undefined"
                @click="clearProducerType()"
                :title="$filters.capitalize($t('producer_types.all'))"
              ></v-list-item>
              <v-list-item
                v-for="p_type in producer_types"
                :key="p_type.full_name"
                :active="p_type.producer_type_id === producer_type_id"
                @click="selectProducerType(p_type)"
              >
                <v-list-item-title>{{ p_type.producer_type_name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-col cols="6" sm="3" md="3" lg="2">
          <!-- unity filter: tracked units / pieces / boxes... -->
          <v-select
            v-model="unityFilterValues"
            :items="unityOptions"
            :label="$filters.capitalize($t('unity.label', 1))"
            prepend-inner-icon="mdi-filter-variant"
            multiple
            chips
            closable-chips
            clearable
            variant="outlined"
            density="comfortable"
            hide-details
          ></v-select>
        </v-col>

        <v-col cols="auto" v-show="hasActiveFilters">
          <v-tooltip location="top" :text="$filters.capitalize($t('part_view.clear_filters'))">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                icon="mdi-filter-remove-outline"
                variant="text"
                size="small"
                @click="clearFilters()"
              ></v-btn>
            </template>
          </v-tooltip>
        </v-col>

        <v-spacer></v-spacer>

        <!-- ================= table tools (right) ================= -->
        <v-col cols="12" md="auto" class="d-flex align-center justify-end">
          <span class="text-caption text-medium-emphasis mr-3">
            {{ items.length }} {{ $t("part_view.label", items.length) }}
          </span>

          <v-btn
            class="mr-2"
            color="primary"
            variant="tonal"
            :disabled="selected.length == 0"
            prepend-icon="mdi-shape"
            @click="changeCategoryBtn()"
          >
            {{ $filters.capitalize($t("actions.choose_category")) }}
            <v-badge
              v-if="selected.length > 0"
              :content="selected.length"
              color="primary"
              inline
              class="ml-1"
            ></v-badge>
          </v-btn>

          <!-- group by category toggle -->
          <v-tooltip location="top" :text="$filters.capitalize($t('part_view.group_by_category'))">
            <template v-slot:activator="{ props }">
              <v-btn
                v-bind="props"
                :icon="grouped ? 'mdi-format-list-group' : 'mdi-format-list-bulleted'"
                :color="grouped ? 'primary' : undefined"
                variant="text"
                @click="toggleGrouped()"
              ></v-btn>
            </template>
          </v-tooltip>

          <!-- column chooser -->
          <v-menu :close-on-content-click="false">
            <template v-slot:activator="{ props: menuProps }">
              <v-tooltip location="top" :text="$filters.capitalize($t('part_view.columns'))">
                <template v-slot:activator="{ props: tipProps }">
                  <v-btn
                    v-bind="{ ...menuProps, ...tipProps }"
                    icon="mdi-view-column"
                    variant="text"
                  ></v-btn>
                </template>
              </v-tooltip>
            </template>
            <v-list density="compact">
              <v-list-item
                v-for="h in allHeaders"
                :key="h.key"
                :disabled="h.required"
                @click="toggleColumn(h.key)"
              >
                <template v-slot:prepend>
                  <v-checkbox-btn
                    :model-value="h.required || visibleColumnKeys.includes(h.key)"
                    :disabled="h.required"
                  ></v-checkbox-btn>
                </template>
                <v-list-item-title>{{ h.title }}</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="resetColumns()">
                <template v-slot:prepend><v-icon>mdi-restore</v-icon></template>
                <v-list-item-title>{{ $filters.capitalize($t("part_view.columns_reset")) }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </template>
    <template v-slot:group-header="{ item, columns, toggleGroup, isGroupOpen, isSelected, toggleSelect }">
      <tr
        class="part-group-header"
        :ref="() => autoOpenGroup(item, toggleGroup, isGroupOpen)"
      >
        <td :colspan="columns.length" class="bg-grey-lighten-4 py-1">
          <div class="d-flex align-center">
            <v-checkbox-btn
              density="compact"
              class="flex-grow-0 mr-1"
              :model-value="isSelected(item.items)"
              @update:model-value="selectGroup(item, isSelected, toggleSelect)"
            ></v-checkbox-btn>
            <v-btn
              size="small"
              variant="text"
              :icon="isGroupOpen(item) ? 'mdi-chevron-down' : 'mdi-chevron-right'"
              @click="toggleGroup(item)"
            ></v-btn>
            <span
              class="font-weight-bold text-uppercase mr-3"
              style="cursor: pointer"
              @click="toggleGroup(item)"
            >{{ item.value || $t("part_view.no_category") }}</span>
            <v-chip size="x-small" label class="mr-2">
              {{ item.items.length }} {{ $t("part_view.label", item.items.length) }}
            </v-chip>
            <v-chip
              v-if="lowStockCount(item) > 0"
              size="x-small"
              label
              color="error"
              prepend-icon="mdi-alert-circle-outline"
            >
              {{ lowStockCount(item) }} {{ $t("part_view.low_stock") }}
            </v-chip>
          </div>
        </td>
      </tr>
    </template>
          <template #item.quantity_combined="{ item }">
        {{ item.min_quantity }} - {{ item.max_quantity }}
      </template>
    <template v-slot:item.category__name="{ item }">
        <span
          v-if="
            $store.getters.language === 'en' && item.category__name_en !== ''
          "
        >
          {{ item.category__name_en }}
        </span>
      <span v-else>
          {{ item.category__name }}
        </span>
    </template>
    <template v-slot:item.unity="{ item }">
      {{ $filters.capitalize($filters.unityFilter(item.unity)) }}
    </template>
    <template v-slot:item.last_adjust="{ item }">
      {{ $filters.formatDate(item.last_adjust) }}
    </template>
<!---
    <template v-slot:item.is_locally_bought="{ item }">
      <v-tooltip location="top" v-if="item.is_locally_bought"
                  :text="$filters.capitalize($t('stock_parts.is_locally_bought_.true') )">
        <template v-slot:activator="{props}">
          <v-icon v-bind="props">mdi-account-eye-outline</v-icon>
        </template>
      </v-tooltip>
      <v-tooltip location="top" v-else :text="$filters.capitalize($t('stock_parts.is_locally_bought_.false') )">
        <template v-slot:activator="{props}">
          <v-icon v-bind="props">mdi-account-lock-outline</v-icon>
        </template>
      </v-tooltip>
    </template>
    --->
    <template v-slot:item.image_url="{ item }">
      <img
        v-if="item.image"
        :src="item.image_url"
        alt=""
        loading="lazy"
        decoding="async"
        class="part_thumb"
        @click="zoom(item.image_url)"
      />
    </template>

    <template v-slot:item.place_names="{item}">{{ item.place_names.join(' , ') }}</template>
    <template v-slot:item.serials="{ item }">
      {{ (item.serials || []).filter((s) => !isNone(s)).join(', ') }}
    </template>
    <template v-slot:item.price="{ item }">
      {{ isNone(item.price) ? '' : $filters.formatPrice(item.price, item.price_currency) }}
    </template>

    <template v-slot:item.qr_codes="{ item }">
      <!-- QR codes of the units in stock (tracked parts only); click opens the units dialog -->
      <span v-if="item.unity == 'un' && Array.isArray(item.qr_codes) && item.qr_codes.length > 0">
        <v-chip
          v-for="code in item.qr_codes.slice(0, qrCodesShown)"
          :key="code"
          size="x-small"
          label
          class="mr-1 mb-1"
          prepend-icon="mdi-qrcode"
          @click="showSerials(item)"
        >{{ code }}</v-chip>
        <v-chip
          v-if="item.qr_codes.length > qrCodesShown"
          size="x-small"
          variant="tonal"
          class="mb-1"
          @click="showSerials(item)"
        >+{{ item.qr_codes.length - qrCodesShown }}</v-chip>
      </span>
    </template>

    <template v-slot:item.actions="{ item }">
      <!-- Native titles: a v-tooltip per icon is one overlay component per
           cell, which is what makes "all rows" slow to render. -->
      <div class="part-actions">
        <v-btn
          icon="mdi-plus"
          size="x-small"
          variant="tonal"
          color="success"
          :title="$filters.capitalize($t('add'))"
          @click="addItemBtn(item)"
        ></v-btn>
        <v-btn
          v-if="isFromStaff && item.quantity > 0"
          icon="mdi-minus"
          size="x-small"
          variant="tonal"
          color="warning"
          :title="$filters.capitalize($t('actions.delete_item'))"
          @click="removeItem(item)"
        ></v-btn>
        <v-btn
          v-if="item.unity == 'un' && item.quantity > 0"
          icon="mdi-barcode"
          size="x-small"
          variant="text"
          color="primary"
          :title="$filters.capitalize($t('actions.show_serials'))"
          @click="showSerials(item)"
        ></v-btn>
        <v-btn
          icon="mdi-pencil-outline"
          size="x-small"
          variant="text"
          :title="$filters.capitalize($t('actions.edit'))"
          @click="createFullPart(item)"
          @click.right="createFullPart_newTab(item)"
        ></v-btn>
        <v-btn
          v-if="isFromStaff"
          icon="mdi-delete-outline"
          size="x-small"
          variant="text"
          color="error"
          :title="$filters.capitalize($t('actions.delete'))"
          @click="disableLine(item)"
        ></v-btn>
      </div>
    </template>
  </v-data-table>
  <CoherenceCheck
      v-if="isFromStaff"
      :stockage_id=stockage_id
      />
</v-container>
</template>

<script>
import { mapState } from "vuex";
import { api } from "@/services/api";
import { useDisplay } from "vuetify";
import filters from "@/mixins/filters";
import utils from "@/mixins/utils";
import {
  alertPopup,
  extractFilename,
  isNone,
  slicyUpdate,
  unProxy,
  customFilter,
} from "@/functions.js";
import CategoryForm from "@/components/CategoryForm";
import ConsumableForm from "@/components/ConsumableForm";
import EditDialog from "@/components/EditDialog";
import MenuStock from "@/components/MenuStock";
import UnitForm from "@/components/UnitForm";
import PartForm from "@/components/PartForm";
import PartQuantityForm from "@/components/PartQuantityForm";
import PartSerialForm from "@/components/PartSerialForm";
import CoherenceCheck from "@/components/part/CoherenceCheck";
import PartMobileCard from "@/components/part/PartMobileCard";

export default {
  mixins: [filters, utils],

  components: {
    EditDialog: EditDialog,
    CategoryForm: CategoryForm,
    ConsumableForm: ConsumableForm,
    MenuStock: MenuStock,
    UnitForm: UnitForm,
    PartForm: PartForm,
    PartQuantityForm: PartQuantityForm,
    PartSerialForm: PartSerialForm,
    CoherenceCheck: CoherenceCheck,
    PartMobileCard: PartMobileCard,
  },

  computed: mapState({
    serialRows() {
      // One row per unit of the selected line: {id, serial, qr_code}.
      // Older API payloads only carry the serials list.
      const line = this.editedLine;
      if (isNone(line)) return [];
      if (Array.isArray(line.units)) return line.units;
      return (line.serials || []).map((serial) => ({
        id: null,
        serial: serial,
        qr_code: null
      }));
    },

    serialHeaders() {
      return [
        {
          title: this.$filters.capitalize(this.$t("units.serial", 1)),
          key: "serial"
        },
        { title: this.$t("units.code"), key: "qr_code" },
        { title: "", key: "actions", sortable: false, align: "end" }
      ];
    },

    module(state) {
      return this.getClassText(state, this.moduleName);
    },
    items() {
      // Producer type is filtered here, on the rows already loaded for the
      // stockage, instead of requesting the API again.
      let rows = this.module.items;
      const producer_type_id = this.producer_type_id;
      if (!isNone(producer_type_id)) {
        rows = rows.filter((row) => {
          const ids = row.producer_type_ids;
          // no producer type on the category = any producer type
          if (!Array.isArray(ids) || ids.length === 0) return true;
          return ids.includes(producer_type_id);
        });
      }
      // unity filter (tracked units, pieces, boxes...) chosen in the toolbar
      if (this.unityFilterValues.length > 0) {
        rows = rows.filter((row) => this.unityFilterValues.includes(row.unity));
      }
      return rows;
    },
    category_id() {
      return this.$store.getters.dataEdit("stock_parts").category_id;
    },
    allHeaders() {
      // Every column the table can show. "required" columns cannot be hidden.
      const c = (k) => this.$filters.capitalize(this.$t(k));
      return [
        { title: this.$t("part_categories.label"), key: "category_name" },
        {
          title: this.$t("stock_parts.name_localized"),
          key: this.$store.getters.language === 'en' ? 'name_en' : 'name'
        },
        { title: this.$t("stock_parts.ref"), key: "ref" },
        { title: "Stock", key: "quantity" },
        { title: "Min-Max", key: "quantity_combined" },
        { title: c("stock_parts.min_quantity"), key: "min_quantity" },
        { title: c("stock_parts.max_quantity"), key: "max_quantity" },
        { title: c("unity.label"), key: "unity", align: "center" },
        { title: this.$t("part_view.serials"), key: "serials", sortable: false },
        { title: c("units.code"), key: "qr_codes", sortable: false },
        { title: this.$t("stock_parts.image"), key: "image_url", sortable: false },
        { title: c("stock_parts.is_locally_bought"), key: "is_locally_bought", align: "center" },
        { title: c("stock_parts.price"), key: "price", align: "end" },
        { title: this.$t("parts.place", 10), key: "place_names" },
        { title: this.$t("actions.label"), key: "actions", sortable: false, required: true },
        { title: this.$t("part_view.last_update"), key: "last_adjust" },
      ];
    },
    visibleColumnKeys() {
      return this.visibleColumns === null ? this.defaultColumns : this.visibleColumns;
    },
    groupBy() {
      // one line per category, parts as sub lines
      return this.grouped ? [{ key: "category_name", order: "asc" }] : [];
    },
    headers() {
      return this.allHeaders.filter(
        (h) => (h.required || this.visibleColumnKeys.includes(h.key))
          && !(this.grouped && h.key === "category_name")
      );
    },
    isMobile() {
      return useDisplay().smAndDown.value;
    },
    canExport() {
      if (this.loadingExport) return false;
      return this.exportMode !== 'at_date' || !!this.exportDate;
    },
    exportDateLabel() {
      if (!this.exportDate) return '';
      return this.exportDate.toLocaleDateString(this.$i18n?.locale || 'fr');
    },
    mobileItems() {
      // phone layout has no data table: apply the text search here,
      // on the same keys as the table
      const query = this.searchQuery;
      if (isNone(query) || query === "") return this.items;
      const keys = ["category_name", "name", "name_en", "ref", "serials", "qr_codes"];
      return this.items.filter((row) =>
        keys.some((k) => customFilter(row[k], query, row))
      );
    },
    mobileGroups() {
      // category -> parts, limited to mobileLimit parts (see "show more")
      const groups = new Map();
      this.mobileItems.slice(0, this.mobileLimit).forEach((item) => {
        const name = item.category_name || "";
        if (!groups.has(name)) groups.set(name, { name: name, items: [], low: 0 });
        const g = groups.get(name);
        g.items.push(item);
        if (this.isLowStock(item)) g.low += 1;
      });
      return Array.from(groups.values());
    },
    hasActiveFilters() {
      return !isNone(this.searchText) && this.searchText !== ""
        || !isNone(this.producer_type_id)
        || this.unityFilterValues.length > 0;
    },
    unityOptions() {
      // unities present in the loaded rows, labelled
      const seen = new Set((this.module.items || []).map((r) => r.unity).filter((u) => !isNone(u)));
      return Array.from(seen).sort().map((u) => ({
        value: u,
        title: this.$filters.capitalize(this.$filters.unityFilter(u) || u),
      }));
    },
    ...utils.isFromStaff
  }),

  created() {
    this.loadColumns();
    try {
      const saved = JSON.parse(localStorage.getItem(this.groupedStorageKey));
      if (typeof saved === "boolean") this.grouped = saved;
    } catch (e) { /* keep default */ }
    // Preload a stockage / producer type
    this.stockage_id = parseInt(this.$route.query.stockage_id) || undefined;
    // loadPage writes the key as "producer_type"; older links use "producer_type_id"
    this.producer_type_id = parseInt(this.$route.query.producer_type) ||
      parseInt(this.$route.query.producer_type_id) || undefined;
  },
  mounted() {
    this.loadPage();
  },

  unmounted() {
    clearTimeout(this.searchTimer);
    this.$store.dispatch("parts/cleanupItems");
    this.$store.dispatch("real_parts/cleanupItems");
  },

  watch: {
    mobileGroups(groups) {
      // open every category panel when the list changes (load, filters)
      this.mobileOpenGroups = groups.map((g) => g.name);
    },
    searchText(val) {
      // Debounce: filtering all rows on every keystroke is what made typing slow
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.searchQuery = isNone(val) ? "" : val;
      }, 250);
    },
    showAddPart(val) {
      if (!val) {
        this.$store.getters.dataEdit("units").serial = "";
      }
    }
  },

  methods: {
    customFilter,
    isNone,
    closeDateSelection() {
      this.exportMode = 'current';
      this.exportDate = undefined;
      this.exportDateMenu = false;
      this.exportDetails = false;
      this.exportFormat = 'CSV';
      this.showDateSelection = false;
    },
    concatItems(placeList) {
      return placeList.join(' '); // Ceci va concaténer les éléments de la liste avec une virgule et un espace
    },

    loadPage() {
      this.disableControls =
        isNone(this.stockage_id)
      if (!isNone(this.stockage_id) && !Number.isNaN(this.stockage_id)) {
        this.loadingStock = true;
        // The whole stockage is loaded once; the producer type is then
        // filtered client side (see the `items` computed).
        let options = {
          size: -1,
          stockage: this.stockage_id,
          lang: this.$store.getters.language
        };
        this.$store.dispatch("real_parts/getView", options).then(() => {
          this.loadingStock = false;
        });
        // Places are not preloaded here: the add unit / consumable dialogs
        // (StockagePlaceForm) and the add part dialog (PartForm) load the
        // places of the stockage themselves when they open.
        this.updateRouteQuery();
      }
    },

    updateRouteQuery() {
      const query = {
        ...this.$router.query,
        stockage_id: this.stockage_id,
        producer_type:this.producer_type_id,
      }
      this.$router.replace({query});
    },

    menuChoose(value) {
      this.stockage_id = value.stockage_id;
      this.producer_type_id = undefined;
      this.setProducerTypes(value.producer_types);
      this.selected = [];
      this.loadPage();
    },

    isLowStock(item) {
      return !isNone(item.min_quantity) && !isNone(item.quantity)
        && item.quantity < item.min_quantity;
    },
    toggleGrouped() {
      this.grouped = !this.grouped;
      this.autoOpenedGroups = {};
      try { localStorage.setItem(this.groupedStorageKey, JSON.stringify(this.grouped)); } catch (e) { /* storage unavailable */ }
    },
    autoOpenGroup(group, toggleGroup, isGroupOpen) {
      // Vuetify groups start collapsed: open each group once, on first render,
      // then leave the user's choice alone.
      if (this.autoOpenedGroups[group.id]) return;
      this.autoOpenedGroups[group.id] = true;
      if (!isGroupOpen(group)) toggleGroup(group);
    },
    selectGroup(group, isSelected, toggleSelect) {
      // select / unselect every part of the category
      const target = !isSelected(group.items);
      group.items.forEach((row) => {
        if (isSelected([row]) !== target) toggleSelect(row);
      });
    },
    lowStockCount(group) {
      return group.items.filter((row) => {
        const r = row.raw || row;
        return !isNone(r.min_quantity) && !isNone(r.quantity) && r.quantity < r.min_quantity;
      }).length;
    },
    clearFilters() {
      this.searchText = "";
      this.unityFilterValues = [];
      if (!isNone(this.producer_type_id)) this.clearProducerType();
    },
    isColumnVisible(key) {
      return this.visibleColumnKeys.includes(key);
    },
    toggleColumn(key) {
      const header = this.allHeaders.find((h) => h.key === key);
      if (!header || header.required) return;
      const keys = [...this.visibleColumnKeys];
      const index = keys.indexOf(key);
      if (index === -1) keys.push(key);
      else keys.splice(index, 1);
      this.visibleColumns = keys;
      this.saveColumns();
    },
    resetColumns() {
      this.visibleColumns = null;
      try { localStorage.removeItem(this.columnsStorageKey); } catch (e) { /* storage unavailable */ }
    },
    saveColumns() {
      try {
        localStorage.setItem(this.columnsStorageKey, JSON.stringify(this.visibleColumns));
      } catch (e) { /* storage unavailable */ }
    },
    loadColumns() {
      try {
        const saved = JSON.parse(localStorage.getItem(this.columnsStorageKey));
        if (Array.isArray(saved)) this.visibleColumns = saved;
      } catch (e) { this.visibleColumns = null; }
    },

    setProducerTypes(producer_types) {
      // Producer types of the current stockage (from MenuStock, on click or
      // on load). Keeps the selected type when it belongs to the stockage.
      this.producer_types = producer_types || [];
      // empty while the stockage list is still loading: keep the current choice
      if (this.producer_types.length === 0) return;
      const current = this.producer_types.find(
        (p) => p.producer_type_id === this.producer_type_id
      );
      if (current) {
        this.producer_type_name = current.producer_type_name;
      } else if (this.producer_types.length === 1) {
        this.producer_type_id = undefined;
        this.producer_type_name = this.producer_types[0].producer_type_name;
      } else {
        this.producer_type_id = undefined;
        this.producer_type_name = this.$t('producer_types.all');
      }
    },

    selectProducerType(value){
      this.producer_type_id = value.producer_type_id
      this.producer_type_name = value.producer_type_name
      this.selected = [];
      this.updateRouteQuery();
    },
    clearProducerType(){
      this.producer_type_id = undefined;
      this.producer_type_name = this.$t('producer_types.all');
      this.selected = [];
      this.updateRouteQuery();
    },

    exportList() {
      this.loadingExport = true;
      this.showDateSelection = false;
      const payload = {
        stockage_id: this.stockage_id,
        producer_type_id: this.producer_type_id
      };
      if (this.expandTrackedPart) {
        payload['expand_tracked_part'] = this.expandTrackedPart
      };
      if (this.exportMode === 'at_date' && this.exportDate) {
        // local YYYY-MM-DD: toISOString() would shift the day to UTC
        const d = this.exportDate;
        payload['at_date'] = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        if (this.exportDetails) {
          payload['details'] = 'True';
        }
      };
      payload['PDF']= this.exportFormat == 'PDF'? 'True' : 'False';

      // the stock export (CSV / PDF of a whole stockage) can take a while:
      // per-request timeout, the global default is left untouched
      api
        .get("parts/export/", { params: payload, timeout: 120000 })
        .then((response) => {
          const blob = new Blob([response.data], { type: "text/csv" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = extractFilename(response.headers, "Export.csv");
          link.click();
          URL.revokeObjectURL(link.href);
          this.loadingExport = false;
        })
        .catch(() => {
          console.error;
          this.loadingExport = false;
        });
    },
    showImportPartEvent() {
      this.showImportPart = true;
      this.$store.dispatch("parts/cleanupEdit");
    },

    createFullPart(item) {
      let query = {
        stockage_id: this.stockage_id,
        producer_type_id: this.producer_type_id
      };
      if (!isNone(item)) {
        query.stock_part_id = item.stock_part_id;
      }
      this.$router.push({ name: "part_edition", query: query });
    },
    createFullPart_newTab(item) {
      let query = {
        stockage_id: this.stockage_id,
        producer_type_id: this.producer_type_id
      };
      if (!isNone(item)) {
        query.stock_part_id = item.stock_part_id;
      }
      const routeData = this.$router.resolve({
        name: "part_edition",
        query: query
      });
      window.open(routeData.href, "_blank");
    },

    removeItem(item) {
      this.isUnit = item.unity == 'un';
      item.pk = item.stock_part_id
      if (this.isUnit) {
        this.$store.dispatch("units/updateEdit", item);
      } else {
        this.$store.dispatch("consumables/updateEdit", item);
        this.$store.state.consumables.edit.quantity = 0;
      }
      this.editedLine = item;
      this.editedStockPartId = item.stock_part_id;
      this.showDeleteItem = true;
    },

    saveDeleteItem() {
      if (this.isUnit) {
        let new_aff= {
                kind: 'ts',
                trash_state_id:1,
                unit_id: this.$store.state.units.search[0].pk,
                ...this.$store.state.units.struct,
            }
        this.$store
          .dispatch('affectations/affect', new_aff)
          .then(() => {
            this.itemsUpdate(
              this.editedLine.pk,
              "serial",
              this.$store.state.units.search[0].serial
            );
            this.$store.dispatch(
              "snackbar/showSuccess",
              this.$t("units.removed_success")
            );
            this.$store.dispatch("units/cleanupEdit");
          });
      } else {
        const rm_quantity = -1 * this.$store.state.consumables.edit.quantity;
        const item = {
          place_id: this.$store.state.consumables.edit.place_ids[0],
          stock_part_id: this.$store.state.consumables.edit.pk,
          quantity: rm_quantity
        };
        this.$store.dispatch(`consumables/addItem`, item).then(() => {
          this.itemsUpdate(this.editedLine.pk, "quantity", rm_quantity);
          this.$store.dispatch(
            "snackbar/showSuccess",
            this.$t("consumables.removed_success")
          );
          this.$store.dispatch("consumables/cleanupEdit");
        });
      }
      this.showDeleteItem = false;
    },

    disableLine(item) {
      // set invisible so as to have prev min max etc if brought back.
      alertPopup(this.$t("dialog.delete_confirm")).then((result) => {
        if (result) {
            this.$store
              .dispatch("real_parts/deleteFullPart", item.stockpartlimit_id).then(() => {
                this.$store.dispatch(
                  "snackbar/showSuccess",
                  this.$t("snack.delete_success")
                );
                this.loadPage();
              });
          }
      });
    },

    showSerials(item) {
      this.editedLine = item;
      this.serialsFilter = "";
      this.showSerialsModal = true;
    },

    viewUnit(unit) {
      // Open the tracked unit page, by id when known, else by QR code
      let query = {};
      if (!isNone(unit.id)) query.part = String(unit.id);
      else if (!isNone(unit.qr_code)) query.qr_code = unit.qr_code;
      else return;
      this.showSerialsModal = false;
      this.$router.push({ name: "unit", query: query });
    },

    zoom(url) {
      // Zoom on this image
      this.imageInLargeSrc = url;
      this.imageInLarge = true;
    },

    itemsUpdate(pk, mode, more) {
      // pk: line identification
      // mode: the key to update
      // more: the value to update
      const index = this.items.findIndex((obj) => obj.pk === pk);
      if (index !== -1) {
        let line = this.items[index];
        if (mode === "quantity") {
          line.quantity = line.quantity + more;
        } else if (mode === "serial") {
          const jndex = line.serials.findIndex((obj) => obj === more);
          const units = Array.isArray(line.units) ? line.units : null;
          const kndex = units ? units.findIndex((u) => u.serial === more) : -1;
          if (jndex !== -1) {
            line.serials.splice(jndex, 1);
            line.quantity = line.quantity - 1;
            if (kndex !== -1) units.splice(kndex, 1);
          } else {
            line.serials.push(more);
            if (units && kndex === -1) {
              units.push({ id: null, serial: more, qr_code: null });
            }
          }
        }
        this.$store.dispatch("parts/setPaginationSize", this.items.length);
      }
    },

    _savePart(edit, line_pk, unity) {
      // Generic method to save a part
      // * edit: which to save
      // * line_pk: which line in the item array
      // * unity: which stock part unity type

      //ugly fix
      if (typeof edit.place_id == 'object') edit.place_id = edit.place_id.pk

      let is_missing = [];
      if (isNone(edit.stock_part_id)) {
        is_missing.push(this.$t("part_view.missing.stockpart"));
      }
      if (isNone(edit.place_id)) {
        is_missing.push(this.$t("part_view.missing.place"));
      }
      if (unity === 'un' &&
        isNone(edit.serial) && isNone(edit.qr_code)) {
          is_missing.push(this.$t("part_view.missing.serial"));
      }
      if (is_missing.length > 0) {
        this.$store.dispatch(
          "snackbar/showWarning",
          this.$t("part_view.missing.sentence", {
            slice: is_missing.join(", ")
          })
        );
        return true;
      }
        this.$store.dispatch(`parts/saveFullPart`, edit).then(() => {
          this.loadPage();
          this.$store.dispatch(
            "snackbar/showSuccess",
            this.$t("parts.added_success")
          );
          this.loadPage();
          this.$store.dispatch('parts/cleanupEdit');
        });
    },

    saveImportStockPart() {
      const edit = this.$store.state.parts.edit;
      this.showImportPart = this._savePart(
        edit,
        undefined,
        this.$store.state.stock_parts.edit.unity
      );
    },

    addItemBtn(item){
    if (item.unity === 'un' ) this.addPartItemBtn(item)
    else this.addConsumableItemBtn(item)
    },

    addConsumableItemBtn(item) {
      this.editedLine = item;
      let stock_part_id = item.stock_part_id;
      this.place_id = item.place_ids[0];
      this.$store.dispatch(`consumables/setEditStockPart`, stock_part_id);
      this.$store.dispatch('places/getItem', this.place_id).then((item)=>{
        this.$store.state.stockages.edit = item.stockage;
        this.showAddConsumable = true;
      })
    },

    // TODO: change this to itemsUpdate?
    saveAddConsumableItem() {
      const edit = this.$store.state.consumables.edit;
      this.showAddConsumable = this._savePart(
        edit,
        this.editedLine.pk,
        this.editedLine.unity
      );
    },

    addPartItemBtn(item) {
      this.editedLine = item;
      this.stock_part_id = item.stock_part_id;
      this.place_id = item.place_ids[0];
      let stock_part_id = item.stock_part_id;
      // The button is used on stock_part_context
      if (stock_part_id !== undefined) {
        this.$store.dispatch(`units/setEditStockPart`, stock_part_id);
      };
      if (!isNone(this.place_id)){

      this.$store.dispatch('places/getItem', this.place_id).then((item)=>{
        this.$store.state.stockages.edit = item.stockage;
        this.showAddPart = true;
      })} else {
        this.$store.dispatch('stockages/getItem', 
          this.stockage_id).then(()=>{this.showAddPart=true})
      }
      // TODO: not do this request if data already there
      // TODO?: stop component (PartForm, etc) from clearing form on closing
    },

    saveAddPartItem() {
      const edit = this.$store.state.units.edit;
      this.showAddPart = this._savePart(
        edit,
        this.editedLine.pk,
        this.editedLine.unity
      );
    },

    changeCategoryBtn() {
      this.$store.dispatch(`stock_parts/cleanupEdit`).then(() => {
        this.editCategory = true;
      });
    },

    saveCategoryEvent() {
      let done = 0;
      for (let key in this.selected) {
        let stock_part_id = this.selected[key];
        this.$store
          .dispatch(`stock_parts/patch`, {
            id_: stock_part_id,
            payload: { category_id: this.category_id }
          })
          .then(() => {
            done = done + 1;
            this.endCategoryMove_question_mark(done);
          })
          .catch(() => {
            done = done + 1;
            this.endCategoryMove_question_mark(done);
          });
      }
      this.$refs.editDialogCategory.closeDialog(); // do reinit of this.category_id
    },

    endCategoryMove_question_mark(done) {
      if (done >= this.selected.length) {
        this.loadPage();
        this.selected = [];
      }
    },

    cleanupCategoryDialog() {
      this.editCategory = false;
      this.$store.dispatch(
        `stock_parts/updateEdit`,
        this.$store.state["stock_parts"].struct
      );
    },

    bgClass(item) {
      let it_ = item.item;
      var classes = [];
      if(!isNone(it_.quantity && it_.min_quantity)){
        if(it_.quantity < it_.min_quantity){
          classes.push("low_quantity")
        } 
      }
      return {class: classes.join(" ")}
    },
  },

  data() {
    return {
      pageTitle: "part_view.label",
      moduleName: "real_parts",
      //headers: [],  // Must be computed
      searchText: "",
      searchQuery: "",
      searchTimer: null,
      itemsPerPage: 10,
      itemsPerPageOptions: [10, 20, 50, -1],
      stockage_id: NaN,
      place_id: NaN,
      stock_part_id: NaN,
      producer_type_id: NaN,
      producer_type_name: this.$t('producer_types.all'),
      producer_types: [],
      loadingExport: false,
      loadingStock: false,
      disableControls: true,
      imageInLarge: false,
      imageInLargeSrc: null,
      showSerialsModal: false,
      serialsFilter: "",
      qrCodesShown: 3, // QR chips displayed per row in the table before "+N"
      unityFilterValues: [], // unity filter of the toolbar (empty = all)
      visibleColumns: null, // user's column choice (null = defaultColumns)
      columnsStorageKey: "part_view_columns",
      grouped: false, // flat list by default; the toggle groups by category
      mobileLimit: 50, // parts rendered in the phone layout before "show more"
      mobileStep: 50,
      mobileOpenGroups: [], // open category panels (phone layout)
      groupedStorageKey: "part_view_grouped",
      autoOpenedGroups: {}, // group ids already opened automatically
      // default visible columns: category (group), name, ref, stock, QR code,
      // image, places; actions is always shown
      defaultColumns: [
        "category_name", "name", "name_en", "ref", "quantity",
        "qr_codes", "image_url", "place_names",
      ],
      showImportPart: false,
      showAddConsumable: false,
      showAddPart: false,
      showDeleteItem: false,
      showDateSelection: false,
      editedLine: undefined,
      selected: [],
      editCategory: false,
      editedStockPartId: undefined,
      isUnit: false,
      helpDialog: false,
      limits: undefined,

      // DATA FOR EXPORT #refactorMePlease
      exportMode: 'current',
      exportDate: undefined,
      exportDateMenu: false,
      exportDetails: false,
      exportFormat: 'CSV',
      expandTrackedPart: undefined,
    };
  }
};
</script>

<style>
table td .v-image {
  cursor: pointer;
}

div.v-dialog__content .v-dialog {
  background-color: white;
}


/*TODO: load these variables.*/
:deep(tr.under_threshold),
:deep(tr.under_threshold.v-data-table__selected) {
  background-color: var(--v-error-lighten3);
}

:deep(tr.under_threshold:hover) {
  background-color: var(--v-error-lighten2) !important;
}

.image-in-large {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.image-in-large img {
  display: block;
  max-width: 100%;
  max-height: 85vh;
  object-fit: contain;
  cursor: default;
}

td .v-image,
td .part_thumb {
  cursor: pointer;
}

td .part_thumb {
  max-height: 32px;
  max-width: 32px;
  object-fit: contain;
  vertical-align: middle;
}

:deep(.unit_header) {
  text-transform: capitalize;
}

tr.low_quantity {
  background-color: #f2c2bd !important;
}

/* phone layout */
.part-mobile__filters {
  position: sticky;
  top: 0;
  z-index: 3;
}
.part-mobile .v-expansion-panel-text__wrapper {
  padding: 8px;
}
.part-mobile__fab {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 4;
}
.part-mobile {
  padding-bottom: 80px; /* room for the floating button */
}

/* actions cell: one compact row of round buttons, never wrapped */
.part-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}
.part-actions .v-btn {
  opacity: 0.75;
  transition: opacity 0.15s;
}
tr:hover .part-actions .v-btn {
  opacity: 1;
}

/* #toolbar {
  z-index: 100;
} */
</style>
